import { render, staticRenderFns } from "./system_management_dictionary.vue?vue&type=template&id=73b69214&scoped=true&"
import script from "./system_management_dictionary.vue?vue&type=script&lang=js&"
export * from "./system_management_dictionary.vue?vue&type=script&lang=js&"
import style0 from "./system_management_dictionary.vue?vue&type=style&index=0&id=73b69214&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b69214",
  null
  
)

export default component.exports